import React, { useState, useEffect, useContext } from 'react';
import axios from '../../axiosConfig';
import TrainerLayout from './TrainerLayout';
import TemplatesManagement from './TemplatesManagement';
import { TrainerContext } from '../../context/TrainerContext';
import '../../styles/TrainerReportsManagement.css';

const TrainerReportsManagement = () => {
    const { trainer } = useContext(TrainerContext);
    const [templates, setTemplates] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    // Fetch templates
    const fetchTemplates = async () => {
        if (!trainer?.schoolId) return;

        try {
            setLoading(true);
            const token = localStorage.getItem('jwt');
            const response = await axios.get(`/api/v1/reports/templates/school/${trainer.schoolId}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setTemplates(response.data);
        } catch (err) {
            console.error('Error fetching templates:', err);
            setError('Nie udało się pobrać szablonów');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchTemplates();
    }, [trainer?.schoolId]);

    // Handle template updates from child component
    const handleTemplatesChange = (updatedTemplates) => {
        setTemplates(updatedTemplates);
    };

    if (!trainer?.schoolId) {
        return (
            <TrainerLayout>
                <div className="trm-container">
                    <h1 className="trm-mobile-title">Raporty</h1>
                    <p className="trm-error">Błąd: Brak danych szkoły</p>
                </div>
            </TrainerLayout>
        );
    }

    return (
        <TrainerLayout>
            <div className="trm-container">
                <h1 className="trm-mobile-title">Raporty</h1>

                {loading ? (
                    <div className="trm-loading">
                        <p>Ładowanie szablonów...</p>
                    </div>
                ) : error ? (
                    <div className="trm-error-container">
                        <p className="trm-error">{error}</p>
                        <button className="trm-retry-btn" onClick={fetchTemplates}>
                            Spróbuj ponownie
                        </button>
                    </div>
                ) : (
                    <TemplatesManagement
                        templates={templates}
                        schoolId={trainer.schoolId}
                        onTemplatesChange={handleTemplatesChange}
                    />
                )}
            </div>
        </TrainerLayout>
    );
};

export default TrainerReportsManagement;